import { useEffect, useMemo, useRef, useState } from 'react'
import styles from './index.less'
import arrowDownFill from '@/assets/icon/arrow_down_fill.svg'
import arrowLeft from '@/assets/icon/arrow_left.svg'
import { Dropdown, Input, Select } from 'antd'
import * as api from '../../api'
import Button from '@/components/Button'
import If from '@/components/If'
import { setHeaders } from '@/utils/request'
import { addCookie, deleteCookie, getCookie } from '@/utils/cookie'
import { setShowRewardPop, useStore } from '@/states/store'
import { openPopDialog } from '@/components/RewordPop'
import RprmUtils from '@/utils/dot'
import InputOTP from '../InputOTP'
import * as Sentry from '@sentry/react'
import { getQuery } from '@/utils'

interface IProps {
  isBind?: boolean
  onLogin?: Function
  regionCodeList: IRegion[]
  closeDialog?: Function
  isCaptchaMode: boolean
  setIsCaptchaMode: Function
  ticket: string
}

// 弹出腾讯图形验证码校验
const ERR_CODE = '45070002000003022'
// 45070002000003022 弹出腾讯图形验证码校验
// 45070002000003013 腾讯图形验证码校验失败

export default ({ isBind, ticket, onLogin, regionCodeList, closeDialog, isCaptchaMode, setIsCaptchaMode = (value: any) => {} }: IProps) => {
  const [areaNo, setAreaNo] = useState('+86')

  const [phoneNum, setPhoneNum] = useState('')

  const [countdown, setCountdown] = useState(0)

  const [loading, setLoading] = useState(false)

  const [disabled, setDisabled] = useState(true)

  const [isNeedTip, setIsNeedTip] = useState(false)
  const [otpValue, setOtpValue] = useState('')

  const inputRef = useRef<any>(null)

  const [isDoted, setIsDoted] = useState(false)
  const query = getQuery()
  const { userInfo } = useStore()

  const regionOpt = useMemo(() => {
    return regionCodeList.map(item => ({
      ...item,
      label: (
        <span>
          {item.zoneName} <span className={styles.areaNum}>{item.displayName}</span>
        </span>
      ),
      key: item.displayName,
    }))
  }, [regionCodeList])

  useEffect(() => {
    if (countdown > 0) {
      setTimeout(() => {
        setCountdown(prev => prev - 1)
      }, 1000)
    }
  }, [countdown])

  useEffect(() => {
    setOtpValue('')
    if (!isCaptchaMode) {
      setCountdown(0)
    }
  }, [isCaptchaMode])

  useEffect(() => {
    if (isNeedTip && inputRef?.current) {
      inputRef.current.focus()
      setOtpValue('')
    }
  }, [isNeedTip])

  const getCaptcha = () => {
    handleNextStep()
  }

  const handleNextStep = async () => {
    if (areaNo === '+86' && phoneNum.length < 11) {
      return
    }
    const sendRes = await api
      .getCaptcha({
        mobileNo: phoneNum,
        zone: regionOpt.find(item => item.key === areaNo)!.zone,
        shareCode: query.shareCode,
      })
      .catch(err => {
        if (err?.errcode === '45070002000003022') {
          api
            .graphicVerification()
            .then(graRes => {
              if (graRes) {
                const { ticket, randstr } = graRes
                api
                  .getCaptcha({
                    ticket,
                    randstr,
                    mobileNo: phoneNum,
                    zone: regionOpt.find(item => item.key === areaNo)!.zone,
                  })
                  .then((res: any) => {
                    setIsCaptchaMode(true)
                    setCountdown(60)
                  })
              }
            })
            .catch(() => {})
        }
      })
    if (sendRes) {
      setIsCaptchaMode(true)
      setCountdown(60)
    }
  }

  const onChangeCaptcha = (code: string) => {
    console.log('🚀 ~ Input.OTP change complete ~ code:', code)
    setOtpValue(code)
    setDisabled(false)
    setLoading(true)
    // if(isBind){
    //   api.updateUserInfo({
    //     mobileNo:phoneNum,
    //     code
    //   }).then((res:any)=>{
    //     if(res?.data?.result){
    //       if(needPop){
    //         openPopDialog()
    //       }
    //       onLogin?.();
    //       closeDialog&&closeDialog()
    //     }
    //   }).catch((err:any)=>{
    //     if(err?.errcode==='45070002000003003'){
    //       setDisabled(true)
    //       setIsNeedTip(true)
    //     }
    //   })
    //   .finally(() => {
    //     setLoading(false);
    //   });

    // }else{
    if (getCookie('token') && userInfo?.channelType === 2) {
      api
        .bindMobile({
          mobileNo: phoneNum,
          zone: regionOpt.find(item => item.key === areaNo)!.zone,
          code,
        })
        .then(async res => {
          if (res) {
            onLogin?.()
          }
        })
        .catch(err => {
          if (err.errcode === '45070002000003003') {
            setDisabled(true)
            setIsNeedTip(true)
          }
        })
        .finally(() => {
          setLoading(false)
        })
        return
    }

    const params: any = {
      loginType: 0,
      code,
      mobileNo: phoneNum,
      qrCodeTicket: ticket,
      zone: regionOpt.find(item => item.key === areaNo)!.zone,
      shareCode: query.shareCode,
    }
    api
      .login(params)
      .then(res => {
        deleteCookie('userId')
        deleteCookie('token')
        res.data?.userId && addCookie('userId', res.data.userId, 24 * 30)
        res.data?.token && addCookie('token', res.data.token, 24 * 30)
        setHeaders()
        if (res?.data?.isPopup) {
          setShowRewardPop(true)
          openPopDialog()
        }
        onLogin?.()
        // closeDialog && closeDialog()
      })
      .catch((err: any) => {
        if (err?.errcode === '45070002000003003') {
          setDisabled(true)
          setIsNeedTip(true)
        }
      })
      .finally(() => {
        setLoading(false)
      })
    // }
  }

  const inputHistoryRef = useRef<string[]>([])
  const otpChange = (v: string) => {
    console.log('🚀 ~ Input.OTP inputChange ~ code:', v)
    // 如果登陆失败 上报这个输入历史 方便排查
    inputHistoryRef.current.push(v)
    setOtpValue(v)
    if (v && isNeedTip) {
      setIsNeedTip(false)
    }
  }

  // console.log("🚀 ~ Input.OTP otpValue :", otpValue)

  const jump = () => {
    // if(needPop){
    openPopDialog()
    // }
    closeDialog && closeDialog()
  }

  const inputChange = (e: any) => {
    const value = e.target.value
    setPhoneNum(value)
    // 1.0.1 手动打点
    if (!isDoted) {
      if (isBind) {
        RprmUtils.rec(`tap_tel_bind_input`, 'view', { en: 'tap', et: 'custom' })
      } else {
        RprmUtils.rec(`tap_tel_login_input`, 'view', { en: 'tap', et: 'custom' })
      }
      setIsDoted(true)
    }
  }

  const getIsDisable = () => {
    if (areaNo === '+86') {
      if (phoneNum.length < 11) {
        return true
      } else {
        return false
      }
    } else {
      if (phoneNum.length <= 0) {
        return true
      } else {
        return false
      }
    }
  }

  return (
    <>
      <If condition={isCaptchaMode}>
        <div className={styles.captchaWrapper}>
          <div className={styles.back} onClick={() => setIsCaptchaMode(false)}>
            {' '}
            <div className="icon-ArrowRight" style={{ fontSize: '16px', marginRight: '4px' }}></div> 返回{' '}
          </div>
          <div className={styles.title}>输入手机验证码</div>
          {!isNeedTip && (
            <div className={styles.tips}>
              请输入发送至 <span style={{ marginRight: '4px' }}>{areaNo}</span>
              <span>{phoneNum}</span> 的 4 位验证码，
              <br />
              有效期 5 分钟
            </div>
          )}
          {isNeedTip && <span className={styles.errTip}>验证码错误，请重新输入</span>}
          <div className={styles.captchaBox}>
            {/* <Input.OTP
              status={isNeedTip ? 'error' : ''}
              autoFocus={true}
              ref={inputRef}
              value={otpValue}
              onChange={onChangeCaptcha}
              className={styles.captcha}
              length={4}
              onInput={otpChange}
            /> */}
            <InputOTP
              status={isNeedTip ? 'error' : ''}
              disabled={loading}
              autoFocus={true}
              ref={inputRef}
              value={otpValue}
              onChange={onChangeCaptcha}
              length={4}
              onInput={otpChange}
            />
          </div>
          {countdown ? (
            <div className={styles.countdown}> {countdown} 秒后可重新获取验证码 </div>
          ) : (
            <a className={styles.getCaptchaBtn} onClick={getCaptcha}>
              重新获取验证码
            </a>
          )}
        </div>
      </If>

      <If condition={!isCaptchaMode}>
        <div className={styles.wrapper}>
          <p className={styles.title}>{isBind ? '绑定手机号' : '验证码登录'}</p>
          <div className={styles.telWrapper}>
            <Dropdown
              getPopupContainer={tr => tr.parentElement?.parentElement?.parentElement || document.body}
              menu={{ items: regionOpt, onClick: arg => setAreaNo(arg.key) }}
              overlayClassName={styles.zoneDrop}
            >
              <div className={styles.areaNo}>
                {areaNo}
                <img src={arrowDownFill} />
              </div>
            </Dropdown>
            <input maxLength={areaNo === '+86' ? 11 : 20} placeholder="请输入手机号" onChange={inputChange} value={phoneNum} />
          </div>
        </div>
      </If>

      {isCaptchaMode ? (
        <div className={styles.btnContainer}>
          <Button disabled={disabled} loading={loading} className={styles.nextStep}>
            {isBind ? '完成绑定' : '登录'}
          </Button>
          {/* {isBind && <div className={styles.tip}>免费领200微力</div>} */}
        </div>
      ) : (
        <div className={styles.btnContainer}>
          <Button onClick={handleNextStep} className={styles.nextStep} disabled={getIsDisable()}>
            下一步
          </Button>
          {/* {isBind && <div className={styles.tip}>免费领200微力</div>} */}
        </div>
      )}
      {/* {isBind&&<div className={styles.jump} onClick={jump}>跳过</div>} */}
    </>
  )
}
